/*
 * Filename: component-tabs.container.tsx
 * Description: component for config tabs.
 */

import React, { Component } from 'react';
import ComponentConfigRootContainer from './component-level-fields/component-config-root-component';
import { LayoutConfigRootComponent } from './layout-level-fields/layout-config-root-component';
import { ConfigHeaderTabs } from './config-tab-header.component';
import { observer } from 'mobx-react';
import { CQMasterDataStore } from '../../store/cq-master-data.store';
import { CQAppConstant } from '../../app-constants';

interface IConfigTabsContainerProps {
    selectedObject:string,
    isLayoutApplicable: boolean;
    templateName: string;
    handleChange: Function;
    updateIconName:(iconClassName:string)=> void;
    componentFields: any[],
    selectedTemplateName: string;
    errors: any,
    resetAndDisableSelectionPanel: Function;
}

class ConfigTabsContainer extends Component<IConfigTabsContainerProps, { componentTabState: boolean }>{
    constructor(props: Readonly<IConfigTabsContainerProps>) {
        super(props);
        this.state = {
            componentTabState: true
        };
    }
    componentDidMount() {
        const outputConfigObj = CQMasterDataStore.OutputConfig;
        const templateObj = outputConfigObj.getStoreData(this.props.selectedTemplateName);
        if (templateObj.className) {
            this.setState({
                componentTabState: !this.state.componentTabState
            });
        }
    }

    togglecomponentTabState = () => {
        this.setState({ componentTabState: !this.state.componentTabState });
    }

    render() {
        return (
            <div className="slds-col full-height">
                <div className="slds-grid slds-grid_vertical slds-tabs_default bg-white full-height">
                    <ConfigHeaderTabs isLayoutApplicable={this.props.isLayoutApplicable}
                        componentTabState={this.state.componentTabState}
                        togglecomponentTabState={this.togglecomponentTabState} 
                        templateName={this.props.templateName} />
                    {
                        this.state.componentTabState &&
                        <ComponentConfigRootContainer errors={this.props.errors}
                            handleChange={this.props.handleChange}
                            updateIconName={this.props.updateIconName}
                            componentFields={this.props.componentFields} 
                            selectedTemplateName={this.props.selectedTemplateName}
                            resetAndDisableSelectionPanel={(value: boolean) => this.props.resetAndDisableSelectionPanel(value)}
                        />
                    }
                    {
                        !this.state.componentTabState &&
                        <LayoutConfigRootComponent selectedObject={this.props.selectedObject} templateName={this.props.templateName} />
                    }
                </div>
            </div>
        );
    }
}

export default observer(ConfigTabsContainer);
